import { DEFAULT_PRICE_RANGE } from "@/constants/filter";

export const getParams = (
  searchParams: Record<string, string | string[] | undefined> | URLSearchParams,
) => {
  const params: Record<string, unknown> = {};

  // Normalize into an array of entries
  let entries: [string, string[]][] = [];

  if (searchParams instanceof URLSearchParams) {
    const keys = Array.from(new Set(searchParams.keys()));
    entries = keys.map((key) => [key, searchParams.getAll(key)]);
  } else {
    entries = Object.entries(searchParams).map(([key, val]) => {
      if (val === undefined) return [key, []];
      return [key, Array.isArray(val) ? val : [val]];
    });
  }

  entries.forEach(([key, values]) => {
    if (values.length === 0) return;

    // Join multiple values with comma for fields that expect comma-separated strings
    const value = values.join(",");

    if (value === "all") return;

    if (key === "price") {
      const [min, max] = value.split("-");
      params["base_price_amount__gte"] = min
        ? Number(min)
        : DEFAULT_PRICE_RANGE.min;
      params["base_price_amount__lte"] = max
        ? Number(max)
        : DEFAULT_PRICE_RANGE.max;
      return;
    }

    if (
      value &&
      (key === "flavour_ids" ||
        key === "tag_ids" ||
        key === "collection_id" ||
        key === "id")
    ) {
      params[key] = value.split(",").map((v: string) => parseInt(v));
      return;
    }

    if (value && value.split(",")?.length > 1) {
      params[`${key}__in`] = value.split(",").map((v: string) => parseInt(v));
      return;
    }

    if (value === "true" || value === "false") {
      params[key] = value === "true";
      return;
    }

    const modifiedValue = parseInt(value || "0");
    params[key] = isNaN(modifiedValue) ? value : modifiedValue;
  });

  return params;
};
